const inputFields = [
  {
    name: "title",
    type: "text",
    label: "Title",
  },
  {
    name: "path",
    type: "text",
    label: "Path",
  },
  {
    name: "image",
    type: "image",
    label: "Image",
  },
  {
    name: "language",
    type: "dynamic_select",
    label: "Select Language",
    placeholder: "",
    options: [],
  },
  {
    name: "category",
    type: "select",
    label: "Category",
    placeholder: "",
    options: [],
  },
  {
    name: "description",
    type: "ckeditor",
    label: "Description",
    placeholder: "",
  },
];

export default inputFields;
